<template>
  <v-container fluid grid-list-md>
      <v-layout wrap align-center justify-center>
        <v-flex md10 xs12>
           <Breadcrumbs :items="breadcrumbs"/>
        </v-flex>
        <v-flex md10 xs12 sm12 align-content-center justify-center>
          <v-card>
            <v-card-text>
              <v-layout row wrap align-center>
                 <v-flex d-flex xs12 sm12 pa-2>

                  <v-expansion-panel v-model="openPanel">

                    <v-expansion-panel-content>
                      <div slot="header">{{ $vuetify.t('$vuetify.SettingsMenu.personal') }}</div>
                      <ProfileSettings @snackbar="toggleSnackbar" />
                    </v-expansion-panel-content>

                    <v-expansion-panel-content>
                      <div slot="header">{{ $vuetify.t('$vuetify.SettingsMenu.notifications') }}</div>
                      <NotificationSettings @snackbar="toggleSnackbar" />
                    </v-expansion-panel-content>

                    <v-expansion-panel-content>
                      <div slot="header">{{ $vuetify.t('$vuetify.SettingsMenu.password') }}</div>
                      <PasswordSettings @snackbar="toggleSnackbar" />
                    </v-expansion-panel-content>

                  </v-expansion-panel>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar v-model="showSnackbar" :bottom="true">
        {{ snackbarMsg }}
        <v-btn
          color="accent"
          flat
          @click="showSnackbar = false"
        >{{ $vuetify.t('$vuetify.Snackbar.close') }}</v-btn>
      </v-snackbar>
  </v-container>
</template>

<script>

import Breadcrumbs from '@/components/Breadcrumbs'

import ProfileSettings from '@/components/ProfileSettings'
import PasswordSettings from '@/components/PasswordSettings'
import NotificationSettings from '@/components/NotificationSettings'

export default {
  $_veeValidate: { validator: 'new' },

  name: 'UserEdit',
  components: {
    Breadcrumbs,
    ProfileSettings,
    PasswordSettings,
    NotificationSettings
  },
  data: function () {
    return {
      openPanel: null,
      showSnackbar: false,
      snackbarMsg: '',
      user: {},
      breadcrumbs: [
        {
          title: 'aula',
          to: '/'
        },
        {
          title: this.$vuetify.t('$vuetify.UserProfile.profile'),
          to: { name: 'Profile', params: { userId: this.$store.getters.user.profile.id } }
        },
        {
          title: this.$vuetify.t('$vuetify.Menu.settings'),
          to: this.$route.path
        }
      ],
      dictionary: {
        custom: {
          new_password_confirm: {
            is: this.$vuetify.t('$vuetify.UserSettings.newPasswordConfirmError')
          },
          old_password: {
            required: this.$vuetify.t('$vuetify.UserSettings.oldPasswordRequired')
          }
        }
      }
    }
  },

  props: {
  },

  beforeMount: function () {
  },

  mounted: function () {
    this.$validator.localize('en', this.dictionary)
  },

  methods: {
    toggleSnackbar () {
      this.showSnackbar = true
      this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.formError')
    }
  }
}
</script>
